import $ from 'jquery';
import { onLoad } from 'runtime';

onLoad(context => {
    const containers = context.querySelectorAll('.featured-products');

    containers.forEach(container => {
        let isDragging = false;
        let startX;
        let scrollLeft;

        // Featured Products - Grab scroll
        container.addEventListener('mousedown', (e) => {
            isDragging = true;
            container.classList.add('active');
            startX = e.pageX - container.offsetLeft;
            scrollLeft = container.scrollLeft;
            e.preventDefault();
        });

        // When the user stops dragging
        container.addEventListener('mouseup', () => {
            isDragging = false;
            container.classList.remove('active');
        });

        // If the user moves the mouse outside the container while dragging
        container.addEventListener('mouseleave', () => {
            isDragging = false; 
            container.classList.remove('active');
        });

        // When the user moves the mouse
        container.addEventListener('mousemove', (e) => {
            if (!isDragging) return;

            e.preventDefault();

            const x = e.pageX - container.offsetLeft;
            const walk = x - startX;

            container.scrollLeft = scrollLeft - walk;
        });

// Find the buttons associated with this instance
        const nextButton = container.parentElement?.querySelector('.featured-products-next');
        const previousButton = container.parentElement?.querySelector('.featured-products-previous');

        const getScrollAmount = () => {
            const page = container.querySelector('.product-grid-item');

            if (!page) return 0;

            const styles = window.getComputedStyle(container);
            const gap = parseFloat(styles.columnGap || styles.gap || 0);

            return page.offsetWidth + gap;
        };

        // Next button
        if (nextButton) {
            nextButton.addEventListener('click', () => {
                const scrollAmount = getScrollAmount();

                if (!scrollAmount) return;

                const maxScrollLeft = container.scrollWidth - container.clientWidth;

                // Return to the beginning if already at the end
                if (container.scrollLeft >= maxScrollLeft - 5) {
                    container.scrollTo({
                        left: 0,
                        behavior: 'smooth'
                    });
                } else {
                    container.scrollBy({
                        left: scrollAmount,
                        behavior: 'smooth'
                    });
                }
            });
        }

        // Previous button
        if (previousButton) {
            previousButton.addEventListener('click', () => {
                const scrollAmount = getScrollAmount();

                if (!scrollAmount) return;

                const maxScrollLeft = container.scrollWidth - container.clientWidth;

                // Return to the end if already at the beginning
                if (container.scrollLeft <= 5) {
                    container.scrollTo({
                        left: maxScrollLeft,
                        behavior: 'smooth'
                    });
                } else {
                    container.scrollBy({
                        left: -scrollAmount,
                        behavior: 'smooth'
                    });
                }
            });
        }
    });
});